import { createApi } from '@reduxjs/toolkit/query/react'
import { AxiosResponse } from 'axios'
import { IUser, TwigLoginResponse, UserPassPayload } from '../../interfaces/auth/IUser'
import { authAxiosQuery } from '../../utils/axios/auth.axios'
import { readFromStorage } from '../../utils/webStorage'
import { IChatResponse } from '../../interfaces/chats/IChatResponse'

export const authApi = createApi({
    reducerPath: 'auth',
    baseQuery: authAxiosQuery(),
    endpoints: (builder) => ({
		authWithAgent: builder.mutation<{data: {
			chatData: IChatResponse[], 
			metadata: {accessToken: string, refreshToken: string}
		}}, { linkToken: string, chatData: IChatResponse[] }>({
			query: (payload) => ({
				url: '/hotel-world-dom/activate-invited-user/chat',
				method: 'PUT',
				data: payload
			})
		}),
		signInWithAgent: builder.mutation<{
			data: {
				chatData: IChatResponse[]
				metadata: {accessToken: string, refreshToken: string}
			},
		}, {
			chatData: IChatResponse[],
		
		}>({
			query: (payload) => ({
				url: '/hotel-world-dom/sign-in/chat',
				method: 'PUT',
				data: payload
			})
		}),
		chatList: builder.mutation<IChatResponse, IChatResponse>({
			query: (payload) => ({
				url: '/agent/signup',
				method: 'POST',
				data: payload
			})
		}),
        login: builder.mutation<TwigLoginResponse, UserPassPayload>({
            query: (payload) => ({
                url: '/dom/login',
                method: 'POST',
                data: payload
            })
        }),
        currentUser: builder.query<AxiosResponse<IUser>, {}>({
            query: (payload) => ({
                url: '/dom/authorize',
                method: 'POST',
                data: payload,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${readFromStorage('accessToken')}`,
                },
            })
        }),
        refreshToken: builder.mutation<TwigLoginResponse, {}>({
            query: () => ({
                url: '/dom/refresh-token',
                method: 'POST',
                data: { token: readFromStorage('refreshToken') },
            })
        }),
    }),
})

export const {
	useAuthWithAgentMutation,
	useSignInWithAgentMutation,
    useLoginMutation,
    useCurrentUserQuery,
    useRefreshTokenMutation
} = authApi